import { TranslationPrefix, attributeDictId, objectDictId, valueDictId, } from "./translation.helpers";
export function createConfigurationTranslateFunctions(options) {
    const { translator: t, translations } = options;
    return {
        objectName(param) {
            const baseDictId = objectDictId(param);
            const dictId = `${baseDictId}.name`;
            const fallback = param.objectId;
            return t(dictId, {
                defaultValue: fallback,
                variables: param.objectInterpolations,
                returnObjects: false,
            });
        },
        objectDescription(param) {
            const baseDictId = objectDictId(param);
            const dictId = `${baseDictId}.description`;
            const fallback = param.objectId;
            return t(dictId, Object.assign(Object.assign({ defaultValue: fallback, variables: param.objectInterpolations }, translations), { returnObjects: false }));
        },
        attributeName(param) {
            const baseDictId = attributeDictId(param);
            const dictId = `${baseDictId}.name`;
            const fallback = param.attributeId;
            return t(dictId, Object.assign(Object.assign({ defaultValue: fallback, variables: param.objectInterpolations }, translations), { returnObjects: false }));
        },
        attributeDescription(param) {
            const baseDictId = attributeDictId(param);
            const dictId = `${baseDictId}.description`;
            const fallback = param.attributeId;
            return t(dictId, Object.assign(Object.assign({ defaultValue: fallback, variables: param.objectInterpolations }, translations), { returnObjects: false }));
        },
        valueName(param) {
            const baseDictId = valueDictId(param);
            const dictId = `${baseDictId}.name`;
            const fallback = param.value;
            return t(dictId, Object.assign({ defaultValue: fallback, variables: param.objectInterpolations }, translations));
        },
        valueDescription(param) {
            const baseDictId = valueDictId(param);
            const dictId = `${baseDictId}.description`;
            const fallback = param.value;
            return t(dictId, Object.assign(Object.assign({ defaultValue: fallback, variables: param.objectInterpolations }, translations), { returnObjects: false }));
        },
        unitName(param) {
            const dictId = `${TranslationPrefix.Units}.${param.unitId}.name`;
            const fallback = param.unitSymbol || param.unitId;
            return t(dictId, Object.assign(Object.assign({ defaultValue: fallback, variables: param.objectInterpolations }, translations), { returnObjects: false }));
        },
        unitDescription(param) {
            const dictId = `${TranslationPrefix.Units}.${param.unitId}.description`;
            const fallback = "";
            return t(dictId, Object.assign(Object.assign({ defaultValue: fallback, variables: param.objectInterpolations }, translations), { returnObjects: false }));
        },
    };
}
//# sourceMappingURL=createConfigurationTranslateFunctions.js.map